import React from "react";
import Header from "../common/Header/Header";
import Footer from "../common/Footer/Footer";
import classes from "./Products.module.css";
import Carousel from "react-elastic-carousel";
import "./arrowstyle.css";

function Products() {
  return (
    <div className="page-wrapper">
      <div className={classes.direction}>
        <div className="oneDirection">EXPORTS</div>
        <div className="oneDirection">IMPORTS</div>
      </div>
      <Header />
      <div className="static-background"></div>
      <div className="sect">
        <div className="sect-title">PRODUCTS</div>
        <div className="sect-title-medium">Waste Paper</div>
        <Carousel
          className={classes.carousel_d}
          itemsToShow={2}
          itemsToScroll={2}
          enableAutoPlay={false}
          autoPlaySpeed={4000}
        >
          <div>
            <img
              alt="product_img"
              className={classes.carousel_img_d}
              src={
                process.env.PUBLIC_URL +
                "assets/images/wastepaper/whitecuttings.jpg"
              }
            />
            <div className={classes.carousel_desc_d}>White Cuttings</div>
          </div>
          <div>
            <img
              alt="product_img"
              className={classes.carousel_img_d}
              src={process.env.PUBLIC_URL + "assets/images/wastepaper/SWL.jpg"}
            />
            <div className={classes.carousel_desc_d}>SWL</div>
          </div>
          <div>
            <img
              alt="product_img"
              className={classes.carousel_img_d}
              src={process.env.PUBLIC_URL + "assets/images/wastepaper/SOP2.jpg"}
            />
            <div className={classes.carousel_desc_d}>SOP - 2</div>
          </div>
          <div>
            <img
              alt="product_img"
              className={classes.carousel_img_d}
              src={
                process.env.PUBLIC_URL +
                "assets/images/wastepaper/ScanBoard.jpg"
              }
            />
            <div className={classes.carousel_desc_d}>Scan Board</div>
          </div>
          <div>
            <img
              alt="product_img"
              className={classes.carousel_img_d}
              src={process.env.PUBLIC_URL + "assets/images/wastepaper/POC.jpg"}
            />
            <div className={classes.carousel_desc_d}>POC</div>
          </div>
          <div>
            <img
              alt="product_img"
              className={classes.carousel_img_d}
              src={process.env.PUBLIC_URL + "assets/images/wastepaper/OCC.jpg"}
            />
            <div className={classes.carousel_desc_d}>OCC</div>
          </div>
          <div>
            <img
              alt="product_img"
              className={classes.carousel_img_d}
              src={
                process.env.PUBLIC_URL + "assets/images/wastepaper/OCC955.jpg"
              }
            />
            <div className={classes.carousel_desc_d}>OCC 95/5</div>
          </div>
          <div>
            <img
              alt="product_img"
              className={classes.carousel_img_d}
              src={
                process.env.PUBLIC_URL +
                "assets/images/wastepaper/kraftbags.jpg"
              }
            />
            <div className={classes.carousel_desc_d}>Kraft Bags</div>
          </div>
          <div>
            <img
              alt="product_img"
              className={classes.carousel_img_d}
              src={process.env.PUBLIC_URL + "assets/images/wastepaper/HWS.jpg"}
            />
            <div className={classes.carousel_desc_d}>HWS</div>
          </div>
          <div>
            <img
              alt="product_img"
              className={classes.carousel_img_d}
              src={process.env.PUBLIC_URL + "assets/images/wastepaper/EOCC.jpg"}
            />
            <div className={classes.carousel_desc_d}>EOCC</div>
          </div>
          <div>
            <img
              alt="product_img"
              className={classes.carousel_img_d}
              src={
                process.env.PUBLIC_URL +
                "assets/images/wastepaper/DSOCCpremium.jpg"
              }
            />
            <div className={classes.carousel_desc_d}>DSOCC Premium</div>
          </div>
          <div>
            <img
              alt="product_img"
              className={classes.carousel_img_d}
              src={
                process.env.PUBLIC_URL + "assets/images/wastepaper/DSOCC.jpg"
              }
            />
            <div className={classes.carousel_desc_d}>DSOCC</div>
          </div>
          <div>
            <img
              alt="product_img"
              className={classes.carousel_img_d}
              src={
                process.env.PUBLIC_URL + "assets/images/wastepaper/cupstock.jpg"
              }
            />
            <div className={classes.carousel_desc_d}>Cupstock</div>
          </div>
          <div>
            <img
              alt="product_img"
              className={classes.carousel_img_d}
              src={process.env.PUBLIC_URL + "assets/images/wastepaper/BHWP.jpg"}
            />
            <div className={classes.carousel_desc_d}>BHWP</div>
          </div>
          <div>
            <img
              alt="product_img"
              className={classes.carousel_img_d}
              src={process.env.PUBLIC_URL + "assets/images/wastepaper/BBC.jpg"}
            />
            <div className={classes.carousel_desc_d}>BBC</div>
          </div>
          <div>
            <img
              alt="product_img"
              className={classes.carousel_img_d}
              src={process.env.PUBLIC_URL + "assets/images/wastepaper/HWEC.jpg"}
            />
            <div className={classes.carousel_desc_d}>HWEC</div>
          </div>
        </Carousel>
        <div className="sect-content">From North America and Canada</div>
        <div className={classes.products_container_d}>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 1</div>
            <div className={classes.products_item_content_d}>
              RESIDENTIAL PAPER
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 2</div>
            <div className={classes.products_item_content_d}>
              SOFT MIX PAPER
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 3</div>
            <div className={classes.products_item_content_d}>
              HARD MIX PAPER
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 4</div>
            <div className={classes.products_item_content_d}>BBC</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 5</div>
            <div className={classes.products_item_content_d}>MILL WRAPPERS</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 6</div>
            <div className={classes.products_item_content_d}>NEWS</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 7</div>
            <div className={classes.products_item_content_d}>NEWS</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 8</div>
            <div className={classes.products_item_content_d}>NEWS</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 9</div>
            <div className={classes.products_item_content_d}>
              OVER ISSUE MAGAZINES
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 10</div>
            <div className={classes.products_item_content_d}>
              OVER ISSUE MAGAZINES
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 11</div>
            <div className={classes.products_item_content_d}>OCC</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 12</div>
            <div className={classes.products_item_content_d}>DSOCC</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 13</div>
            <div className={classes.products_item_content_d}>NDLKC</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 14</div>
            <div className={classes.products_item_content_d}>FIBER CORES</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 15</div>
            <div className={classes.products_item_content_d}>
              USED BROWN KRAFT
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 16</div>
            <div className={classes.products_item_content_d}>
              MIXED KRAFT CUTTINGS
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 17</div>
            <div className={classes.products_item_content_d}>CARRIER KRAFT</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 20</div>
            <div className={classes.products_item_content_d}>
              KRAFT MULTI WALL BAG SCRAP
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 122</div>
            <div className={classes.products_item_content_d}>
              MIXED GROUND WOOD SHAVINGS
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 23</div>
            <div className={classes.products_item_content_d}>
              TELEPHONE DIRECTORIES
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 25</div>
            <div className={classes.products_item_content_d}>
              GROUND WOOD COMPUTER PRINT OUT
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 27</div>
            <div className={classes.products_item_content_d}>
              FLY LEAF SHAVINGS
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 28</div>
            <div className={classes.products_item_content_d}>
              COATED SOFT WHITE SHAVINGS
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 30</div>
            <div className={classes.products_item_content_d}>
              HARD WHITE SHAVINGS
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 31</div>
            <div className={classes.products_item_content_d}>
              HARD WHITE ENVELOPE CUTTINGS
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 33</div>
            <div className={classes.products_item_content_d}>
              NEW COLORED ENVELOPE CUTTINGS
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 35</div>
            <div className={classes.products_item_content_d}>
              SEMI BLEACHED CUTTINGS
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 36</div>
            <div className={classes.products_item_content_d}>
              UNSORTED OFFICE PAPER
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 37</div>
            <div className={classes.products_item_content_d}>
              SORTED OFFICE PAPER
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 39</div>
            <div className={classes.products_item_content_d}>
              MANIFOLD COLOR LEDGER
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 40</div>
            <div className={classes.products_item_content_d}>
              SORTED WHITE LEDGER
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 41</div>
            <div className={classes.products_item_content_d}>
              MANIFOLD WHITE LEDGER
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 42</div>
            <div className={classes.products_item_content_d}>
              COMPUTER PRINT OUT
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 43</div>
            <div className={classes.products_item_content_d}>
              COATED BOOK STOCK
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>PS 44</div>
            <div className={classes.products_item_content_d}>
              COATED GROUND WOOD SECTIONS
            </div>
          </div>
        </div>
        <div className="sect-content">Speciality Grades</div>
        <div className={classes.products_container_d}>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>1-S</div>
            <div className={classes.products_item_content_d}>
              WHITE WAXED CUP CUTTINGS
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>2-S</div>
            <div className={classes.products_item_content_d}>
              PRINTED WAXED CUP CUTTINGS
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>3-S</div>
            <div className={classes.products_item_content_d}>
              POLY COATED CUP
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>4-S</div>
            <div className={classes.products_item_content_d}>
              PRINTED POLY COATED BLEACHED KRAFT
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>5-S</div>
            <div className={classes.products_item_content_d}>
              UNPRINTED POLY COATED BLEACHED KRAFT
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>6-S</div>
            <div className={classes.products_item_content_d}>
              POLY COATED MILK CARTON STOCK
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>8-S</div>
            <div className={classes.products_item_content_d}>
              POLY COATED BOARD CUTTINGS
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>9-S</div>
            <div className={classes.products_item_content_d}>
              WAXED BOX BOARD CUTTINGS
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>10-S</div>
            <div className={classes.products_item_content_d}>
              PRINTED OR UNPRINTED BLEACHED SULPHATE WITH FOIL
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>11-S</div>
            <div className={classes.products_item_content_d}>
              WAXED CORRUGATED CUTTINGS
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>12-S</div>
            <div className={classes.products_item_content_d}>
              WET STRENGTH CORRUGATED CUTTINGS
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>14-S</div>
            <div className={classes.products_item_content_d}>
              BEER CARTON SCRAP
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>15-S</div>
            <div className={classes.products_item_content_d}>
              CONTAMINATED BAG SCRAP
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>17-S</div>
            <div className={classes.products_item_content_d}>
              WHITE WET STRENGTH SCRAP
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>18-S</div>
            <div className={classes.products_item_content_d}>
              BROWN WET STRENGTH SCRAP
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>19-S</div>
            <div className={classes.products_item_content_d}>
              PRINTED AND COLORED WET STRENGTH SCRAP
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>20-S</div>
            <div className={classes.products_item_content_d}>FILE STOCK</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>22-S</div>
            <div className={classes.products_item_content_d}>RULED WHITE</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>23-S</div>
            <div className={classes.products_item_content_d}>
              FLYLEAF SHAVINGS WITH HOT MELT GLUE
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>24-S</div>
            <div className={classes.products_item_content_d}>CARBON MIX</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>25-S</div>
            <div className={classes.products_item_content_d}>
              BOOKS WITH COVERS
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>30-S</div>
            <div className={classes.products_item_content_d}>
              PLASTIC WINDOWED ENVELOPES
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>35-S</div>
            <div className={classes.products_item_content_d}>
              SORTED COLOR LEDGER
            </div>
          </div>
        </div>
        <div className="sect-content">From Continental Europe and UK</div>
        <div className={classes.products_container_d}>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>MIXED PAPER</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              EUROPEAN OLD CORRUGATES CARTONS (EOCC)
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>FRUIT BOXES</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>TOBACCO BOXES</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              NEW CORRUGATED CUTTINGS (NCC)
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              KRAFT CARRIER BOARD (KCB)
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              MULTIWALL PAPER BAGS
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>NEWS & PAMS</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              OVER ISSUE NEWS PAPER (OINP)
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              OLD MAGAZINES (OMG)
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              MAGAZINE TRIMS
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              COATED BOOK STOCK (CBS)
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>MULTI GRADE</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              SORTED OFFICE PACK/SORTED COLOR LETTERS (SOP)
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>CUP STOCK</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              UNPRINTED CUP STOCK WITH POLY ON ONE SIDE, ALL SULPHATE
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              CUP STOCK POLY COATED ON ONE SIDE WITH PRINTING ON POLY, ALL
              SULPHATE
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              CUP STOCK UN PRINTED WITH BOTH SIDE POLY WITH 5% BCTMP
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              PLASTIC WHITE ENVELOPES (PWE)
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              HARD WHITE SHAVINGS/ SOFT WHITE SHAVINGS (HWS/SWS)
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>SCAN BOARD</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              BOX BOARD CUTTINGS (BBC)
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              STEEL MILL KRAFT
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              FROM MIDDLE EAST AND AFRICA
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              OLD CORRUGATED CARTONS (OCC)
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              NEW CORRUGATED CARTONS (NCC)
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              BOX BOARD CUTTINGS (BBC)
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              OVER ISSUE NEWSPAPERS #9 (OINP)
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>SCAN BOARD</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              PRINTERS OFF CUT (POC)
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              OVER ISSUE MAGAZINE
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              PURE WHITE CUTTINGS (PWC)
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              SORTED WHITE LEDGER (SWL)
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              LIGHT COLOR CUTTINGS (LCC)
            </div>
          </div>
        </div>
        <div className="sect-content">From Middle East</div>
        <div className={classes.products_container_d}>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              NEW CORRUGATED CUTTINGS (NCC)
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              KRAFT CARRIER BOARD (KCB)
            </div>
          </div>

          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              OVER ISSUE NEWS PAPER (OINP)
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              OLD MAGAZINES (OMG)
            </div>
          </div>

          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              COATED BOOK STOCK (CBS)
            </div>
          </div>

          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              SORTED OFFICE PACK/SORTED COLOR LETTERS (SOP)
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>CUP STOCK</div>
          </div>

          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              CUP STOCK POLY COATED ON ONE SIDE WITH PRINTING ON POLY, ALL
              SULPHATE
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              CUP STOCK UN PRINTED WITH BOTH SIDE POLY WITH 5% BCTMP
            </div>
          </div>

          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              HARD WHITE SHAVINGS/ SOFT WHITE SHAVINGS (HWS/SWS)
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>SCAN BOARD</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              BOX BOARD CUTTINGS (BBC)
            </div>
          </div>

          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              OLD CORRUGATED CARTONS (OCC)
            </div>
          </div>

          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              BOX BOARD CUTTINGS (BBC)
            </div>
          </div>

          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              PRINTERS OFF CUT (POC)
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              OVER ISSUE MAGAZINE
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              PURE WHITE CUTTINGS (PWC)
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_content_d}>
              SORTED WHITE LEDGER (SWL)
            </div>
          </div>
        </div>
      </div>
      <div className="sect">
        <div className="sect-title-medium">Silicon and Ferro Silicon</div>
        <div className="sect-content">SILICON METAL</div>
        <Carousel
          className={classes.carousel_d}
          itemsToShow={2}
          itemsToScroll={2}
          enableAutoPlay={false}
          autoPlaySpeed={4000}
        >
          <div>
            <img
              alt="product_img"
              className={classes.carousel_img_d}
              src={process.env.PUBLIC_URL + "assets/images/silicon/4411.jpg"}
            />
            <div className={classes.carousel_desc_d}>441</div>
          </div>
          <div>
            <img
              alt="product_img"
              className={classes.carousel_img_d}
              src={process.env.PUBLIC_URL + "assets/images/silicon/5531.jpg"}
            />
            <div className={classes.carousel_desc_d}>553</div>
          </div>
          <div>
            <img
              alt="product_img"
              className={classes.carousel_img_d}
              src={process.env.PUBLIC_URL + "assets/images/silicon/4412.jpg"}
            />
            <div className={classes.carousel_desc_d}>441</div>
          </div>
          <div>
            <img
              alt="product_img"
              className={classes.carousel_img_d}
              src={process.env.PUBLIC_URL + "assets/images/silicon/5532.jpg"}
            />
            <div className={classes.carousel_desc_d}>553</div>
          </div>
        </Carousel>
        <div className="sect-content">
          Silicon, ferrosilicon and other silicon alloys are produced by
          reducing quartz, with coal and iron or other ores at very high
          temperatures (2000°C) in electric arc furnaces. Metallurgical silicon
          metal is used as an alloying agent in the Aluminium industry due to
          its ability to increase the strength of Aluminium. The Silicon makes
          the metal alloy more fluid without breaking the metal down at high
          temperatures. <br />
          We supply the following grades:
        </div>
        <div className={classes.tableContainer_d}>
          <div className={classes.tableColumn_d}>
            <div className={classes.tableColumnTitle_d}>Silicon metal</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>2202</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>3303</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>441</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>553</div>
          </div>
          <div className={classes.tableColumn_d}>
            <div className={classes.tableColumnTitle_d}>Si</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              99.5%<span className={classes.tableUnit_d}>min</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              99.5%<span className={classes.tableUnit_d}>min</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              99.0%<span className={classes.tableUnit_d}>min</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              98.5%<span className={classes.tableUnit_d}>min</span>
            </div>
          </div>
          <div className={classes.tableColumn_d}>
            <div className={classes.tableColumnTitle_d}>Fe</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.20%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.30%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.40%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.50%<span className={classes.tableUnit_d}>max</span>
            </div>
          </div>
          <div className={classes.tableColumn_d}>
            <div className={classes.tableColumnTitle_d}>Al</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.20%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.30%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.40%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.50%<span className={classes.tableUnit_d}>max</span>
            </div>
          </div>
          <div className={classes.tableColumn_d}>
            <div className={classes.tableColumnTitle_d}>Ca</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.02%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.03%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.10%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.30%<span className={classes.tableUnit_d}>max</span>
            </div>
          </div>
        </div>
        <div className="sect-content">FERRO SILICON</div>
        <div className="sect-content">
          An alloy of Iron and Silicon containing 15% to 95% silicon and is used
          for deoxidizing molten steel and making silicon steel and high-silicon
          cast iron. Ferrosilicon is usually smelted in closed submerged arc
          furnaces with a power of 22 to 93 MVA
        </div>
        <div className="sect-content">SPECIFICATIONS</div>
        <div className={classes.tableContainer_d}>
          <div className={classes.tableColumn_d}>
            <div className={classes.tableColumnTitle_d}>Ferro Silicon</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Mn</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Si</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>C</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>P</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>S</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Size</div>
          </div>
          <div className={classes.tableColumn_d}>
            <div className={classes.tableColumnTitle_d}>&nbsp;</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>70%-75%</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.20%/0.15%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              2%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.03%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.04%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              10-50mm(90% <span className={classes.tableUnit_d}>min</span>){" "}
              <br />
              or any other required size.
            </div>
          </div>
        </div>
        <div className={classes.tableContainer_d}>
          <div className={classes.tableColumn_d}>
            <div className={classes.tableColumnTitle_d}>
              H.C.FERRO
              <br />
              CHROME
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Cr</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Si</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>C</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>P</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>S</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Size</div>
          </div>
          <div className={classes.tableColumn_d}>
            <div className={classes.tableColumnTitle_d}>
              &nbsp;
              <br />
              &nbsp;
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>60%-65%</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              3.0%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              8.0%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.03%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.05%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              10-100mm(90% <span className={classes.tableUnit_d}>min</span>){" "}
              <br />
              or any other required size.
            </div>
          </div>

          <div className={classes.tableColumn_d}>
            <div className={classes.tableColumnTitle_d}>
              H.C.FERRO
              <br />
              CHROME
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Cr</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Si</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>C</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>P</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>S</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Size</div>
          </div>
          <div className={classes.tableColumn_d}>
            <div className={classes.tableColumnTitle_d}>
              &nbsp;
              <br />
              &nbsp;
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>55%-60%</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              4.0%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              8.0%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.04%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.06%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              10-150mm(90% <span className={classes.tableUnit_d}>min</span>){" "}
              <br />
              or any other required size.
            </div>
          </div>
        </div>
        <div className={classes.tableContainer_d}>
          <div className={classes.tableColumn_d}>
            <div className={classes.tableColumnTitle_d}>
              H.C.FERRO CHROME CHIPS
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Cr</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Si</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>C</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>P</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>S</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Size</div>
          </div>
          <div className={classes.tableColumn_d}>
            <div className={classes.tableColumnTitle_d}>
              &nbsp;
              <br />
              &nbsp;
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>58%-62%</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              4.0%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              9.0%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.04%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.05%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              3-10mm(90% <span className={classes.tableUnit_d}>min</span>){" "}
              <br />
              or any other required size.
            </div>
          </div>

          <div className={classes.tableColumn_d}>
            <div className={classes.tableColumnTitle_d}>
              H.C.FERRO CHROME FINES
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Cr</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Si</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>C</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>P</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>S</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Size</div>
          </div>
          <div className={classes.tableColumn_d}>
            <div className={classes.tableColumnTitle_d}>
              &nbsp;
              <br />
              &nbsp;
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>56%-60%</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              4.0%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              9.0%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.04%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.06%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0-3mm(90% <span className={classes.tableUnit_d}>min</span>) <br />
              or any other required size.
            </div>
          </div>
        </div>
        <div className={classes.tableContainer_d}>
          <div className={classes.tableColumn_d}>
            <div className={classes.tableColumnTitle_d}>
              H.C.FERRO
              <br />
              MANGANESE
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Mn</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Si</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>C</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>P</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>S</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Size</div>
          </div>
          <div className={classes.tableColumn_d}>
            <div className={classes.tableColumnTitle_d}>
              &nbsp;
              <br />
              &nbsp;
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>70%-75%</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              1.5%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              8.00%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.30%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.030%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              10-50mm(90% <span className={classes.tableUnit_d}>min</span>){" "}
              <br />
              or any other required size.
            </div>
          </div>

          <div className={classes.tableColumn_d}>
            <div className={classes.tableColumnTitle_d}>
              H.C.FERRO
              <br />
              MANGANESE
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Mn</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Si</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>C</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>P</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>S</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Size</div>
          </div>
          <div className={classes.tableColumn_d}>
            <div className={classes.tableColumnTitle_d}>
              &nbsp;
              <br />
              &nbsp;
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>75%-80%</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              1.5%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              8.00%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.25%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.030%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              10-150mm(90% <span className={classes.tableUnit_d}>min</span>){" "}
              <br />
              or any other required size.
            </div>
          </div>
        </div>
        <div className={classes.tableContainer_d}>
          <div className={classes.tableColumn_d}>
            <div className={classes.tableColumnTitle_d}>
              SILICO
              <br />
              MANGANESE
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Mn</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Si</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>C</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>P</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>S</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Size</div>
          </div>
          <div className={classes.tableColumn_d}>
            <div className={classes.tableColumnTitle_d}>
              &nbsp;
              <br />
              &nbsp;
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>60%-65%</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              14.0%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              2.5%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.30%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.030%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              10-50mm(90% <span className={classes.tableUnit_d}>min</span>){" "}
              <br />
              or any other required size.
            </div>
          </div>

          <div className={classes.tableColumn_d}>
            <div className={classes.tableColumnTitle_d}>
              SILICO
              <br />
              MANGANESE
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Mn</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Si</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>C</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>P</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>S</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Size</div>
          </div>
          <div className={classes.tableColumn_d}>
            <div className={classes.tableColumnTitle_d}>
              &nbsp;
              <br />
              &nbsp;
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>65%-70%</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              16.0<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              2.00%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.25%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              0.030%<span className={classes.tableUnit_d}>max</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              10-50mm(90% <span className={classes.tableUnit_d}>min</span>){" "}
              <br />
              or any other required size.
            </div>
          </div>
        </div>
        <div className="sect-title-medium">Aluminium Scrap</div>
        <Carousel
          className={classes.carousel_d}
          itemsToShow={2}
          itemsToScroll={2}
          enableAutoPlay={false}
          autoPlaySpeed={4000}
        >
          <div>
            <img
              alt="product_img"
              className={classes.carousel_img_d}
              src={
                process.env.PUBLIC_URL + "assets/images/aluminium/altense.jpg"
              }
            />
            <div className={classes.carousel_desc_d}>Al Tense</div>
          </div>
          <div>
            <img
              alt="product_img"
              className={classes.carousel_img_d}
              src={
                process.env.PUBLIC_URL + "assets/images/aluminium/extrusion.jpg"
              }
            />
            <div className={classes.carousel_desc_d}>Al Extrusion</div>
          </div>
          <div>
            <img
              alt="product_img"
              className={classes.carousel_img_d}
              src={process.env.PUBLIC_URL + "assets/images/aluminium/fscu.jpg"}
            />
            <div className={classes.carousel_desc_d}>Al wheels</div>
          </div>
          <div>
            <img
              alt="product_img"
              className={classes.carousel_img_d}
              src={process.env.PUBLIC_URL + "assets/images/aluminium/img1.jpg"}
            />
            <div className={classes.carousel_desc_d}>Al Taint Tabor</div>
          </div>
          <div>
            <img
              alt="product_img"
              className={classes.carousel_img_d}
              src={process.env.PUBLIC_URL + "assets/images/aluminium/img2.jpg"}
            />
            <div className={classes.carousel_desc_d}>Al wheels</div>
          </div>
        </Carousel>
        <div className="sect-content">
          Aluminium does not lose quality when it is reused. Metal loss is
          minimal when recycling, and the environmental advantage substantial.
          When aluminium is reused instead of extracting new Aluminium, it saves
          95% of the energy.
          <br />
          Aluminium can be smelted and shaped an infinite number of times. This
          makes aluminium a renewable raw material with an unbeatable
          environmental footprint. <br />
          We deal in all types of aluminium scrap: sheet aluminium, cast
          aluminium, profiles, rims, swarf and offset plates.
          <br />
          Aluminium scrap: as per ISRI specifications
        </div>
        <div className={classes.products_container_d}>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>Tablet</div>
            <div className={classes.products_item_content_d}>
              (Lithographic sheets)
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>Taboo</div>
            <div className={classes.products_item_content_d}>
              (Mixed nw, low Cu/Zn)
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>Taint Tabor</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>Tally</div>
            <div className={classes.products_item_content_d}>(Radiators)</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>Talk</div>
            <div className={classes.products_item_content_d}>
              (with or without Iron)
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>
              Talon-Tann-Taste
            </div>
            <div className={classes.products_item_content_d}>(wire)</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>Telic</div>
            <div className={classes.products_item_content_d}>
              (Borings-turnings)
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>Tense</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>Tutu</div>
            <div className={classes.products_item_content_d}>(Profiles)</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>Almg</div>
            <div className={classes.products_item_content_d}>(5xxx)</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>ACSR</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>UBC</div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>Tough/Taboo</div>
            <div className={classes.products_item_content_d}>
              (Mixed solids)
            </div>
          </div>
          <div className={classes.products_item_d}>
            <div className={classes.products_item_title_d}>Troma</div>
            <div className={classes.products_item_content_d}>
              (wheels-auto or truck)
            </div>
          </div>
        </div>
      </div>

      <div className="sect">
        <div className="sect-title-medium">Castorseed/Oilseed/Rapeseed meals</div>
        <Carousel
          className={classes.carousel_d}
          itemsToShow={2}
          itemsToScroll={2}
          enableAutoPlay={false}
          autoPlaySpeed={4000}
        >
          <div>
            <img
              alt="Castor seed meal"
              className={classes.carousel_img_d}
              src={
                process.env.PUBLIC_URL +
                "assets/images/csm/5daf5a150c451780743076283e4b768.jpg"
              }
            />
            <div className={classes.carousel_desc_d}>Castor Seed Meal</div>
          </div>
          <div>
            <img
              alt="Oyster mushroom"
              className={classes.carousel_img_d}
              src={
                process.env.PUBLIC_URL +
                "assets/images/csm/edible-mushroom-zqa.jpg"
              }
            />
            <div className={classes.carousel_desc_d}>Oyster Mushroom</div>
          </div>
        </Carousel>

        <div className={classes.infoBlock_d}>
          <div className={classes.infoTitle_d}>CASTOR SEED MEAL</div>
          <div className={classes.infoText_d}>
            Castor seed meal is a by-product of the castor oil extraction process.
            It is made by grinding the castor seeds that remain after the oil has
            been extracted. Castor meal is also variously called castor meal,
            castor residue, castor extract &amp; de-oiled castor cake. Castor meal –
            the residue obtained from castor cake by the solvent extraction process
            – is one of the most versatile natural manures.
            <br />
            <br />
            Castor seed meal is a high-protein, high-fibre ingredient that is
            commonly used as a fertilizer for crops. Castor seed meal is a good
            source of nitrogen, phosphorus, and potassium, as well as other
            essential nutrients. It is often used as an organic alternative to
            chemical fertilizers because it is slow-release and helps improve soil
            fertility over time. It also has traces of nutrients like Manganese,
            Zinc and Copper, thus making it a balanced fertilizer. Moreover, it
            helps to neutralize the detrimental effects of chemical fertilizers.
            <br />
            <br />
            However, it should be noted that castor seed meal contains ricin, a
            toxic compound that can be harmful to both humans and animals, so it
            should be used with caution and can only be used in animal feed
            formulations after detoxification of castor cake. The solvent extracted
            cake, although rich in protein cannot be used as cattle fodder because
            of its toxicity, however, it can be used as a fertilizer.
          </div>
        </div>

        <div className={classes.infoBlock_d}>
          <div className={classes.infoTitle_d}>BENEFITS</div>
          <div className={classes.infoText_d}>
            - Provides all the major &amp; minor nutrients necessary for better plant
            growth. <br />- Helps increase nutrient uptake by plants. <br />-
            Improves soil fertility and productivity. <br />- Known to protect plants
            from nematodes and termites. <br />- Improves yield &amp; quality of farm
            produce. <br />- Improves the physical, chemical and biological
            properties of soil.
          </div>
        </div>

        <div className={classes.infoBlock_d}>
          <div className={classes.infoTitle_d}>USES</div>
          <div className={classes.infoText_d}>
            Fertilizer: Castor meal is a good organic fertilizer that can be used
            to improve soil fertility. It contains nitrogen, phosphorus, and
            potassium, which are essential nutrients for plant growth.
            <br />
            Industrial uses: Castor meal can be used as a raw material for the
            production of biofuels, biopolymers, and other industrial products.
          </div>
        </div>

        <div className="sect-content">CASTOR SEEDS MEAL HIGH PROTEIN SPECIFICATION</div>
        <div className={classes.tableContainer_d}>
          <div className={classes.tableColumn_d}>
            <div className={classes.tableColumnTitle_d}>Parameter</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Protein</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Nitrogen</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Potassium</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Phosphorus</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Moisture</div>
          </div>
          <div className={classes.tableColumn_d}>
            <div className={classes.tableColumnTitle_d}>Value</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              50% <span className={classes.tableUnit_d}>min</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              8% <span className={classes.tableUnit_d}>min</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              1% <span className={classes.tableUnit_d}>min</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              1% <span className={classes.tableUnit_d}>min</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              12% <span className={classes.tableUnit_d}>max</span>
            </div>
          </div>
        </div>

        <div className="sect-content">CASTOR SEEDS MEAL LOW PROTEIN SPECIFICATION</div>
        <div className={classes.tableContainer_d}>
          <div className={classes.tableColumn_d}>
            <div className={classes.tableColumnTitle_d}>Parameter</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Nitrogen</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Potassium</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Phosphorus</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>Moisture</div>
          </div>
          <div className={classes.tableColumn_d}>
            <div className={classes.tableColumnTitle_d}>Value</div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              4% <span className={classes.tableUnit_d}>min</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              1% <span className={classes.tableUnit_d}>min</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              1% <span className={classes.tableUnit_d}>min</span>
            </div>
            <div className={classes.separator_d}></div>
            <div className={classes.tableContent_d}>
              12% <span className={classes.tableUnit_d}>max</span>
            </div>
          </div>
        </div>

        <div className="sect-content">GENERAL SPECIFICATIONS</div>
        <div className={classes.infoBlock_d}>
          <div className={classes.infoText_d}>
            Organic Matter: 80 to 85% <br />
            Protein: ~30% <br />
            Nitrogen: 4-4.5% min <br />
            Phosphorous: 1% min <br />
            Potassium: 1% min <br />
            Moisture: 10 - 12% max <br />
            Oil Content: 0.5% <br />
            Packing Details: 25kg, 50kg PP Bags
          </div>
        </div>

        <div className={classes.infoBlock_d}>
          <div className={classes.infoTitle_d}>SOYBEAN MEAL</div>
          <div className={classes.infoText_d}>
            Soybean meal is a by-product obtained after the extraction of oil
            from soybeans. Soybean meal is a popular source of protein in animal
            feed, particularly for livestock such as poultry, swine, and cattle.
            It is also used in aquaculture and pet food. Soybean meal is a
            cost-effective and nutrient-dense feed ingredient, with high protein
            content (around 50%) and significant levels of essential amino acids,
            minerals, and vitamins.
          </div>
        </div>

        <div className={classes.infoBlock_d}>
          <div className={classes.infoTitle_d}>
            RAPESEED MEAL (DE-OILED MUSTARD CAKE)
          </div>
          <div className={classes.infoText_d}>
            Mustard de-oiled cake is a by-product obtained during the production
            of mustard oil. After the mustard oil is extracted from mustard
            seeds, the remaining material is pressed to remove any residual oil,
            resulting in a cake-like substance. This cake is rich in protein,
            fibre, and minerals and can be used as a nutritious animal feed or
            organic fertilizer.
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Products;
